import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { Button, withStyles } from '@material-ui/core';

import { post } from '../modules/utility';
import FormSelect from '../components/form/FormSelect';
import localStorage from '../libs/localStorage';
import DateNavigation from './FleetCalendar/DateNavigation';
import UserBody from './FleetCalendar/UserBody';
import CalendarProblems from './FleetCalendar/CalendarProblems';
import LocationMultiSelect from './advancedForm/LocationMultiSelect';
import Paper from '@material-ui/core/Paper';
import ShiftSelect from './advancedForm/ShiftSelect';
import { getNumberOfDaysBreakPoint } from '../libs/calendarConfig';
import FormText from './form/FormText';
import { DatePicker } from '@material-ui/pickers';
import AuthUserContainer from '../containers/AuthUser';
import AddUserAssignmentDialog from './FleetCalendar/AddUserAssignmentDialog';
import { CALENDAR_TYPE } from './FleetCalendar/constants';
import UserTypeMultiSelect from './advancedForm/UserTypeMultiSelect';

const styles = () => {
	return {
		paper: {
			//width: '100%',
			width: 'max-content',
			minWidth: '100%',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			borderRadius: 0,
			marginBottom: 20,
		},
		headerContainer: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'left',
			marginBottom: 15,
		},
		dateArea: {
			flex: 1,
			display: 'flex',
			alignItems: 'flex-end',
			justifyContent: 'left',
		},
		settingsArea: {
			display: 'flex',
			alignItems: 'flex-end',
			justifyContent: 'right',
		},
		dateRange: {
			display: 'flex',
			flexDirection: 'row',
			fontSize: 30,
			//fontFamily: "'Roboto Condensed', sans-serif",
			fontWeight: 100,
			color: '#555',
			letterSpacing: '-1px',
			marginRight: 20,
			marginBottom: -5,
		},
		dateRangeStart: {
			padding: '5px 5px',
			border: '1px solid transparent',
			borderBottom: '1px solid #bbb',
			borderRadius: '2px',
			cursor: 'pointer',
			transition: '0.3s',
			'&:hover': {
				border: '1px solid #aaa',
				backgroundColor: `#f5f5f5`,
			},
		},
		dateRangeStartInput: {
			fontSize: 30,
			fontWeight: 100,
			color: '#555',
			letterSpacing: '-1px',
		},
		dateRangeEnd: {
			padding: '5px 5px',
		},
		setting: {
			marginLeft: 10,
			marginRight: 10,
			minWidth: 150,
		},
		addUserButton: {
			fontSize: 12,
		},
	};
};

const dateRangeOptions = [
	{
		display: '5 Days Out',
		value: 5,
	},
	{
		display: '7 Days Out',
		value: 7,
	},
	{
		display: '15 Days Out',
		value: 15,
	},
	{
		display: '28 Days Out',
		value: 28,
	},
	{
		display: 'Monthly',
		value: 'oneMonth',
	},
];

function getSortByOptions(calendarType) {
	if (calendarType === CALENDAR_TYPE.users) {
		return [
			{
				display: 'Shift Time',
				value: 'shiftTime',
			},
			{
				display: 'Schedule',
				value: 'schedule',
			},
			{
				display: 'Location',
				value: 'location',
			},
			{
				display: 'First Name',
				value: 'firstName',
			},
			{
				display: 'Last Name',
				value: 'lastName',
			},
			{
				display: 'Truck',
				value: 'truck',
			},
		];
	} else if (calendarType === CALENDAR_TYPE.trucks) {
		return [
			{
				display: 'Shift Time',
				value: 'shiftTime',
			},
			{
				display: 'Schedule',
				value: 'schedule',
			},
			{
				display: 'Location',
				value: 'location',
			},
			{
				display: 'Truck',
				value: 'truck',
			},
		];
	}
}

function getControlDisplayState(p = {}) {
	const today = moment().format('YYYY-MM-DD');

	const startDate = p.startDate || today;
	const dateRangeOption = p.dateRangeOption || 7;
	//const numberOfDays = p.numberOfDays || 3;

	let endDate;

	if (dateRangeOption === 'oneMonth') {
		endDate = moment(startDate).endOf('month').format('YYYY-MM-DD');
	} else {
		endDate = moment(startDate)
			.add(dateRangeOption - 1, 'days')
			.format('YYYY-MM-DD');
	}
	const numberOfDays = moment(endDate).diff(moment(startDate), 'days') + 1;

	const dateColumns = [];
	const processMoment = moment(startDate);
	let processDate = '';

	const getDisplayPieces = (mom) => {
		return {
			day: mom.format('D'),
			month: mom.format('MMM'),
			year: mom.format('YYYY'),
		};
	};

	const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
	const largeStyle = { fontSize: '80%', fontWeight: 400 };

	const startDisplayPieces = getDisplayPieces(processMoment);
	while (processDate !== endDate) {
		processDate = processMoment.format('YYYY-MM-DD');

		let display = processMoment.format('ddd M/D');
		if (nodIsLarge) {
			display = (
				<Fragment>
					<div style={largeStyle}>{processMoment.format('M/D')}</div>
					<div style={largeStyle}>{processMoment.format('ddd')}</div>
				</Fragment>
			);
		}

		processMoment.add(1, 'days');
		dateColumns.push({
			date: processDate,
			display,
		});
	}
	processMoment.subtract(1, 'days');
	const endDisplayPieces = getDisplayPieces(processMoment);

	let dateRangeStart;
	let dateRangeEnd;
	let dateRangeStartValue;
	//- Years match don't show it
	if (startDisplayPieces.year === endDisplayPieces.year) {
		dateRangeStart = `${startDisplayPieces.month} ${startDisplayPieces.day}`;
		dateRangeStartValue = startDate;
		dateRangeEnd = `${endDisplayPieces.month} ${endDisplayPieces.day}, ${endDisplayPieces.year}`;
	} else {
		dateRangeStart = `${startDisplayPieces.month} ${startDisplayPieces.day}, ${startDisplayPieces.year}`;
		dateRangeEnd = `${endDisplayPieces.month} ${endDisplayPieces.day}, ${endDisplayPieces.year}`;
	}

	if (dateRangeOption === 'oneMonth') {
		dateRangeStart = `${startDisplayPieces.month} ${startDisplayPieces.year}`;
	}

	return {
		dateRangeStartValue,
		dateRangeStart,
		dateRangeEnd,
		today: moment().format('YYYY-MM-DD'),
		startDate,
		endDate,
		dateColumns,
		dateRangeOption,
		numberOfDays,
	};
}

class FleetCalendar extends Component {
	constructor(props) {
		super(props);

		const dateRangeOption =
			localStorage.getItem(this.getStorageKey('dateRangeOption')) || dateRangeOptions[2].value;
		const hideOpenShifts = localStorage.getItem(this.getStorageKey('hideOpenShifts')) || false;
		const sortBy =
			localStorage.getItem(this.getStorageKey('sortBy')) ||
			getSortByOptions(props.calendarType)[0].value;
		const locationIds = localStorage.getItem(this.getStorageKey('locationIds')) || [];
		const userTypes = localStorage.getItem(this.getStorageKey('userTypes')) || ['drivers'];
		let shiftIds = localStorage.getItem(this.getStorageKey('shiftIds')) || [1];

		const expandedCalendarProblems = localStorage.getItem(
			this.getStorageKey('expandedCalendarProblems')
		);
		// const expandedOpenShifts = localStorage.getItem(this.getStorageKey('expandedOpenShifts'));

		if (!_.isArray(shiftIds)) {
			shiftIds = [shiftIds];
		}

		let startDate;
		if (dateRangeOption === 'oneMonth') {
			startDate = moment().startOf('month').format('YYYY-MM-DD');
		} else {
			startDate = moment().format('YYYY-MM-DD');
		}

		this.state = {
			isStartDateOpen: false,
			searching: false,
			searchErrors: undefined,
			addUserAssignmentDialogIsOpen: false,
			userFilter: '',
			expandedCalendarProblems,
			// expandedOpenShifts,
			sortBy,
			locationIds,
			userTypes,
			shiftIds,
			dateRangeOption,
			hideOpenShifts,
			...getControlDisplayState({
				startDate,
				dateRangeOption,
			}),
		};
	}

	getStorageKey(key) {
		const { calendarType } = this.props;
		// Legacy
		if (calendarType === CALENDAR_TYPE.users) {
			return `/calendar-drivers-${key}`;
		} else {
			return `/calendar-${calendarType}-${key}`;
		}
	}

	refreshCalendarData = () => {
		this.search();
	};

	search = () => {
		const { startDate, endDate, locationIds, shiftIds } = this.state;

		this.setState({ searching: true });

		post({
			method: 'workDay.search',
			params: {
				startDate,
				endDate,
				locationIds,
				shiftIds,
			},
			callback: (err, r) => {
				if (err) {
					return this.setState({
						searching: false,
						searchErrors: err,
					});
				}

				const processedSearchResult = this.processSearchResult({
					searchResult: r,
					locationIds,
					shiftIds,
					hideOpenShifts: this.state.hideOpenShifts,
				});

				this.setState({
					searching: false,
					searchResult: r,
					processedSearchResult,
				});
			},
		});
	};

	processSearchResult = ({ searchResult, locationIds, hideOpenShifts, shiftIds = [] }) => {
		const { collections } = searchResult;

		const workDays = _.get(collections, 'workDayCollection', []);
		const openTrucks = _.get(collections, 'openTruckCollection', []);
		const unavailableTrucks = _.get(collections, 'unavailableTruckCollection', []);

		const userMap = _.keyBy(_.get(collections, 'userCollection', []), 'userId');
		const shiftMap = _.keyBy(_.get(collections, 'shiftCollection', []), 'shiftId');
		const locationMap = _.keyBy(_.get(collections, 'locationCollection', []), 'locationId');

		//- its a group because drivers could switch schedules mid segment
		const userAssignments = _.get(collections, 'userAssignmentCollection', []);

		// Process the result
		const workDayMap = _.keyBy(workDays, 'workDayId');
		const userWorkDaysByDate = _.groupBy(workDays, 'date');
		const openTrucksByDate = _.groupBy(openTrucks, 'date');
		const openTruckMap = _.keyBy(openTrucks, 'openTruckId');
		const unavailableTrucksByDate = _.groupBy(unavailableTrucks, 'date');
		const unavailableTruckMap = _.keyBy(unavailableTrucks, 'unavailableTruckId');

		// const userGroups = _.groupBy(workDays, 'userId');

		const workDaysGroupedByUserAndShift = {};
		workDays.forEach((workDay) => {
			const { shiftId, userAssignmentId } = workDay;
			const useShiftId = shiftId;

			const key = `${userAssignmentId}_${useShiftId}`;
			if (!workDaysGroupedByUserAndShift[key]) {
				workDaysGroupedByUserAndShift[key] = [];
			}
			workDaysGroupedByUserAndShift[key].push(workDay);
		});

		const now = moment();
		const userRows = _.reduce(
			userAssignments,
			(acc, userAssignment) => {
				const {
					userAssignmentId,
					userId,
					locationId,
					shiftId,
					shiftTime,
					endDate,
					userAssignmentTypeId,
				} = userAssignment;

				if (!_.includes(locationIds, locationId)) {
					return acc;
				}

				if (endDate && moment(endDate).isBefore(now)) {
					return acc;
				}

				const user = userMap[userId] || { display: 'Missing' };

				// for sorting
				if (!shiftId || !shiftTime) {
					console.log('ShiftId or shiftTime is missing');
					return acc;
				}

				if (!_.includes(shiftIds, shiftId)) {
					return;
				}

				//- Determine user and workDays
				const key = `${userAssignmentId}_${shiftId}`;
				const workDaysForUser = workDaysGroupedByUserAndShift[key] || [];

				const userWorkDaysByDate = workDaysForUser.reduce((acc, workDay) => {
					const date = workDay.date;
					if (!acc[date]) {
						acc[date] = [];
					}
					acc[date].push(workDay);
					return acc;
				}, {});

				const row = {
					key: `${userAssignmentId}_${shiftId}`,
					userAssignmentId,
					userAssignment,
					//users,
					userAssignmentTypeId,
					locationId,
					shiftId,
					shiftTime,
					user,
					//activeUserAssignment,
					//inactiveUserAssignment,

					// sort
					truckNumber: user.display,
					userWorkDaysByDate,
				};
				acc.push(row);
				return acc;
			},
			[]
		);

		return {
			workDayMap,
			userRows: _.orderBy(userRows, ['userAssignmentTypeId', 'shiftTime', 'truckNumber']),
			userWorkDaysByDate,
			openTrucksByDate,
			openTruckMap,
			unavailableTrucksByDate,
			unavailableTruckMap,
			userMap,
			shiftMap,
			locationMap,
		};
	};

	componentDidMount() {
		this.search();
	}

	onChangeExpandCalendarProblems = (event, expanded) => {
		localStorage.setItem(this.getStorageKey('expandedCalendarProblems'), expanded);
		this.setState({
			expandedCalendarProblems: expanded,
		});
	};

	onChangeExpandOpenShifts = (event, expanded) => {
		localStorage.setItem(this.getStorageKey('expandedOpenShifts'), expanded);
		this.setState({
			expandedOpenShifts: expanded,
		});
	};

	onChangeDateRangeOption = (value) => {
		localStorage.setItem(this.getStorageKey('dateRangeOption'), value);

		let startDate;
		if (value === 'oneMonth') {
			startDate = moment().startOf('month').format('YYYY-MM-DD');
		} else {
			startDate = moment().format('YYYY-MM-DD');
		}

		this.setState(
			{
				...getControlDisplayState({
					startDate,
					dateRangeOption: value,
				}),
			},
			this.search
		);
	};

	onChangeHideOpenShifts = (value) => {
		localStorage.setItem(this.getStorageKey('hideOpenShifts'), value);
		this.setState(
			{
				hideOpenShifts: value,
			},
			this.search
		);
	};

	onChangeSortBy = (value) => {
		localStorage.setItem(this.getStorageKey('sortBy'), value);

		this.setState({
			sortBy: value,
		});
	};

	onChangeLocationIds = (value) => {
		localStorage.setItem(this.getStorageKey('locationIds'), value);

		this.setState(
			{
				locationIds: value,
			},
			this.search
		);
	};

	onChangeUserTypes = (value) => {
		localStorage.setItem(this.getStorageKey('userTypes'), value);

		this.setState(
			{
				userTypes: value,
			},
			this.search
		);
	};

	onUserFilter = (value) => {
		this.setState({ userFilter: value });
	};

	onChangeShiftIds = (value) => {
		localStorage.setItem(this.getStorageKey('shiftIds'), value);

		this.setState(
			{
				shiftIds: value,
			},
			this.search
		);
	};

	onDateNavigation = (startDate) => {
		const { dateRangeOption } = this.state;

		this.setState(
			{
				...getControlDisplayState({
					startDate,
					dateRangeOption,
				}),
			},
			this.search
		);
	};

	setStartDate = (date) => {
		const { dateRangeOption } = this.state;
		const startDate = moment(date).format('YYYY-MM-DD');

		this.setState(
			{
				...getControlDisplayState({
					startDate,
					dateRangeOption,
				}),
			},
			this.search
		);
	};

	setStartDateOpen = (isStartDateOpen) => {
		this.setState({ isStartDateOpen });
	};

	// Handle adding a new user

	// Add new assignment
	handleAddUserAssignment = () => {
		this.setState({
			addUserAssignmentDialogIsOpen: true,
			locationIdForAddUserAssignment: null,
			userAssignmentTypeIdForAddUserAssignment: null,
		});
	};
	handleAddUserAssignmentDialogClose = () => {
		this.setState({
			addUserAssignmentDialogIsOpen: false,
			locationIdForAddUserAssignment: undefined,
			userAssignmentTypeIdForAddUserAssignment: undefined,
		});
	};
	handleRefreshDataFromDialog = () => {
		this.refreshCalendarData();
	};

	render() {
		const { calendarType, classes, permissions } = this.props;
		const canAddUser = permissions && _.includes(permissions, 'canOverrideScheduleAssignments');

		const {
			today,
			startDate,
			searchResult,
			processedSearchResult,
			dateColumns,
			dateRangeOption,
			hideOpenShifts,
			numberOfDays,
			sortBy,
			locationIds,
			userTypes,
			shiftIds,
			userFilter,
			expandedCalendarProblems,
			// expandedOpenShifts,
		} = this.state;

		const bodyProps = {
			today,
			sortBy,
			numberOfDays,
			searchResult,
			processedSearchResult,
			dateColumns,
			calendarType,
			refreshCalendarData: this.refreshCalendarData,
			locationIds,
			userTypes,
			userFilter,
			hideOpenShifts,
			shiftIds,
		};

		return (
			<Paper className={classes.paper}>
				<CalendarProblems
					expanded={expandedCalendarProblems}
					onChange={this.onChangeExpandCalendarProblems}
					searchResult={searchResult}
					locationIds={locationIds}
					userTypes={userTypes}
				/>

				<div className={classes.headerContainer}>
					<div className={classes.dateArea}>
						{this.renderDateRange()}

						<DateNavigation
							startDate={startDate}
							onChange={this.onDateNavigation}
							today={today}
							numberOfDays={numberOfDays}
							dateRangeOption={dateRangeOption}
						/>

						<div style={{ marginLeft: 20, flexShrink: 1 }}>
							<FormText
								path="userFilter"
								onChange={this.onUserFilter}
								label={'Name filter'}
								value={userFilter}
							/>
						</div>
					</div>

					<div className={classes.settingsArea}>
						<div className={classes.setting}>
							<UserTypeMultiSelect
								path="userTypes"
								onChange={this.onChangeUserTypes}
								label={'People'}
								value={userTypes}
							/>
						</div>

						<div className={classes.setting}>
							<LocationMultiSelect
								path="locationIds"
								onChange={this.onChangeLocationIds}
								label={'Locations'}
								value={locationIds}
							/>
						</div>

						<div className={classes.setting}>
							<ShiftSelect
								label="Shifts"
								path="shiftIds"
								value={shiftIds}
								onChange={this.onChangeShiftIds}
								selectMultiple={true}
							/>
						</div>

						<div className={classes.setting}>
							<FormSelect
								label="View"
								value={dateRangeOption}
								path="dateRangeOption"
								onChange={this.onChangeDateRangeOption}
								options={dateRangeOptions}
							/>
						</div>

						<Button
							variant="outlined"
							className={classes.addUserButton}
							color="primary"
							onClick={() => {
								this.handleAddUserAssignment();
							}}
							disabled={!canAddUser}
						>
							Add User
						</Button>

						<AddUserAssignmentDialog
							open={this.state.addUserAssignmentDialogIsOpen}
							locationId={this.state.locationIdForAddUserAssignment}
							userAssignmentTypeId={this.state.userAssignmentTypeIdForAddUserAssignment}
							onClose={this.handleAddUserAssignmentDialogClose}
							onRefreshData={this.handleRefreshDataFromDialog}
						/>
					</div>
				</div>
				<UserBody {...bodyProps} />
			</Paper>
		);
	}

	renderDateRange = () => {
		const { classes } = this.props;

		const {
			dateRangeOption,
			dateRangeStart,
			dateRangeStartValue,
			dateRangeEnd,
			isStartDateOpen,
		} = this.state;

		if (dateRangeOption === 'oneMonth') {
			return (
				<div className={classes.dateRange}>
					<div>
						<div className={classes.dateRangeStart} onClick={() => this.setStartDateOpen(true)}>
							{dateRangeStart}
						</div>
						<div style={{ display: 'none' }}>
							<DatePicker
								open={isStartDateOpen}
								onOpen={() => this.setStartDateOpen(true)}
								onClose={() => this.setStartDateOpen(false)}
								label={''}
								value={dateRangeStartValue || null}
								onChange={this.setStartDate}
								openTo={'month'}
								views={['month']}
								format={'MMM'}
							/>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className={classes.dateRange}>
					<div>
						<div className={classes.dateRangeStart} onClick={() => this.setStartDateOpen(true)}>
							{dateRangeStart}
						</div>
						<div style={{ display: 'none' }}>
							<DatePicker
								open={isStartDateOpen}
								onOpen={() => this.setStartDateOpen(true)}
								onClose={() => this.setStartDateOpen(false)}
								label={''}
								value={dateRangeStartValue || null}
								onChange={this.setStartDate}
								showTodayButton
								animateYearScrolling
								format={'D, MMM'}
							/>
						</div>
					</div>
					<div className={classes.dateRangeEnd}>- {dateRangeEnd}</div>
				</div>
			);
		}
	};
}

FleetCalendar.propTypes = {
	classes: PropTypes.object.isRequired,
	calendarType: PropTypes.oneOf(['users', 'trucks']),
};
FleetCalendar.defaultProps = {
	calendarType: 'users',
};

export default _.flow([withStyles(styles), AuthUserContainer])(FleetCalendar);
